module.exports = __webpack_public_path__ + "static/img/pitch_black_HQ.db1b96a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pitch_black_HQ.png
// module id = qoTF
// module chunks = 94